module.exports = __webpack_public_path__ + "static/img/seed.b1214ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bench/seed.png
// module id = MqUS
// module chunks = 1